import axios from 'axios';

// Get the base URL from environment variables
const BASE_URL = import.meta.env.VITE_BASE_URL;

// Create an axios instance
const axiosInstance = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add a request interceptor to add the token, but skip for open routes like login
axiosInstance.interceptors.request.use(
  (config) => {
    if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }

    // Get the current route
    const openRoutes = ['/admin/auth']; // Add any other routes that don't require auth here

    // If the route is an open route (no token required), skip adding the Authorization header
    if (!openRoutes.includes(config.url || '')) {
      // Get the access token from localStorage (or wherever you store it)
      const token = localStorage.getItem('accessToken');

      // If the token exists, add it to the headers
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor for refresh token logic
axiosInstance.interceptors.response.use(
  (response) => response, // If the response is successful, just return it
  async (error) => {
    const originalRequest = error.config;

    // If the error is a 401 (Unauthorized) and the request hasn't been retried
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Call your refresh token API endpoint here to get a new token
        const refreshToken = localStorage.getItem('refreshToken');
        const { data } = await axios.post(`${BASE_URL}/api/admin/auth/refresh`, {
          refreshToken: refreshToken,
        });

        // Save the new access token and retry the original request
        localStorage.setItem('accessToken', data.accessToken);
        originalRequest.headers['Authorization'] = `Bearer ${data.accessToken}`;

        return axiosInstance(originalRequest); // Retry the original request
      } catch (refreshError) {
        // Handle the error (maybe redirect to login if refresh fails)
        console.error('Token refresh failed:', refreshError);
        return Promise.reject(refreshError);
      }
    }

    // If the error is not related to token expiration, just reject the promise
    return Promise.reject(error);
  }
);

export default axiosInstance;
